import {BannerService} from '@/common/api/banner.service'
import {
    BANNER_DELETE,
    BANNER_GET, BANNERS_GET,
    // BANNER_DELETE,
    // BANNER_CREATE
} from './actions/banner.type'
import {REMOVE_BANNER, SET_BANNER, SET_BANNER_INDEX, SET_BANNERS} from './mutations/banner.type'
import {CHANGE_PROGRESS} from './mutations/mutations.type'


const initialState = () => {
    return {
        banner: {
            name: '',
            image: ''
        },
        banners: []
    }
}

export const state = initialState()

const getters = {
    banner: state => {
        return state.banner
    },
    banners: state => {
        return state.banners
    }
}

const mutations = {
    [SET_BANNER](state, data) {
        state.banner = data
    },
    [SET_BANNERS](state, data) {
        if (Array.isArray(data)) {
            let len = data.length - 1
            if (len < 0) {
                len = 0
            }
            for (let i = data.length; i < 6; i++) {
                data.push({
                    id: 0,
                    image: "",
                })
            }

            state.banners = data
        }
    },
    [SET_BANNER_INDEX](state, data) {
        state.banners.splice(data.index, 1, data.obj)
    },
    [REMOVE_BANNER](state, index) {
        state.banners.splice(index, 1, {id: 0, image: "",})
    },

}

const actions = {
    async [BANNER_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await BannerService.get()
        commit(SET_BANNER, data)
        commit(CHANGE_PROGRESS, false)
        console.log('action', data);
    },
    async [BANNERS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await BannerService.list();
        commit(SET_BANNERS, data);

        commit(CHANGE_PROGRESS, false)
    },
    async [BANNER_GET]({commit}, data) {
        // commit(CHANGE_PROGRESS, true);
        const resp = await BannerService.get(data.id);

        commit(SET_BANNER_INDEX, {index: data.index, obj: {id: data.id, image: resp}});
        // commit(CHANGE_PROGRESS, false)
    },
    async [BANNER_DELETE](_, id) {
        return BannerService.delete(id);
    },

}

export default {
    state,
    actions,
    mutations,
    getters
}